"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityConversionStatusToJSON = exports.CommunityConversionStatusFromJSONTyped = exports.CommunityConversionStatusFromJSON = exports.CommunityConversionStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var CommunityConversionStatus;
(function (CommunityConversionStatus) {
    CommunityConversionStatus["PENDINGTRANSFER"] = "PENDING_TRANSFER";
    CommunityConversionStatus["PENDINGREVIEW"] = "PENDING_REVIEW";
    CommunityConversionStatus["APPROVED"] = "APPROVED";
    CommunityConversionStatus["DECLINED"] = "DECLINED";
    CommunityConversionStatus["COMPLETED"] = "COMPLETED";
})(CommunityConversionStatus = exports.CommunityConversionStatus || (exports.CommunityConversionStatus = {}));
function CommunityConversionStatusFromJSON(json) {
    return CommunityConversionStatusFromJSONTyped(json, false);
}
exports.CommunityConversionStatusFromJSON = CommunityConversionStatusFromJSON;
function CommunityConversionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CommunityConversionStatusFromJSONTyped = CommunityConversionStatusFromJSONTyped;
function CommunityConversionStatusToJSON(value) {
    return value;
}
exports.CommunityConversionStatusToJSON = CommunityConversionStatusToJSON;
